import(/* webpackMode: "eager" */ "/workdir/Chrono1010-eCommerce.Web/ClientApp/src/app/[lang]/error.tsx");
